import { useEffect, useState } from "react";
import { api } from "../lib/api.js";
import { loginWithPasskey, registerPasskey } from "../lib/auth.js";

export function Login({ onAuthed }: { onAuthed: () => void }) {
  const [registered, setRegistered] = useState<boolean | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [addMode, setAddMode] = useState(false);
  const [code, setCode] = useState("");

  useEffect(() => {
    api
      .authStatus()
      .then((s) => {
        if (s.authed) onAuthed();
        else setRegistered(s.registered);
      })
      .catch(() => setRegistered(false));
  }, [onAuthed]);

  async function handle(fn: () => Promise<boolean>) {
    setBusy(true);
    setError(null);
    try {
      const ok = await fn();
      if (ok) onAuthed();
      else setError("Authentication failed.");
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="login-card">
        <div className="brand"><span className="brand-mark" />ATLAS</div>
        <p className="tagline">Your voice-controlled agent.</p>
        {registered === null ? (
          <p className="muted">Checking…</p>
        ) : !registered ? (
          <button className="primary" disabled={busy} onClick={() => handle(registerPasskey)}>
            {busy ? "Setting up…" : "Set up this device"}
          </button>
        ) : addMode ? (
          <>
            <input
              className="code-input"
              inputMode="numeric"
              placeholder="6-digit code"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            />
            <button
              className="primary"
              disabled={busy || code.length < 6}
              onClick={() => handle(() => registerPasskey(code))}
            >
              {busy ? "Adding…" : "Add this device"}
            </button>
            <button className="linkbtn" onClick={() => setAddMode(false)}>
              Back to unlock
            </button>
          </>
        ) : (
          <>
            <button className="primary" disabled={busy} onClick={() => handle(loginWithPasskey)}>
              {busy ? "Unlocking…" : "Unlock with passkey"}
            </button>
            <button className="linkbtn" onClick={() => setAddMode(true)}>
              Set up this device with a code
            </button>
          </>
        )}
        {error && <p className="error">{error}</p>}
        <p className="hint">Face ID / Touch ID. No passwords.</p>
        {addMode && (
          <p className="hint">
            On a device you're already signed in on: Settings → Add a device → enter that code here.
          </p>
        )}
      </div>
    </div>
  );
}
